(function () {
  function initMdbLpMedia(wrapper) {
    const video = wrapper.querySelector('video');
    const toggle = wrapper.querySelector('[data-mdb-lp-sound-toggle]');
    if (!video || !toggle) return;

    const labelOn = toggle.getAttribute('data-label-on') || 'Turn sound on';
    const labelOff = toggle.getAttribute('data-label-off') || 'Turn sound off';
    const textOn = toggle.getAttribute('data-text-on') || 'Sound on';
    const textOff = toggle.getAttribute('data-text-off') || 'Sound off';
    const textEl = toggle.querySelector('.mdb-lp-media__sound-toggle-text');

    function syncToggle() {
      const isMuted = video.muted;
      toggle.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
      toggle.setAttribute('aria-label', isMuted ? labelOn : labelOff);
      toggle.classList.toggle('is-unmuted', !isMuted);
      if (textEl) textEl.textContent = isMuted ? textOn : textOff;
    }

    function unmute() {
      video.muted = false;
      video.play().catch(function () {});
      syncToggle();
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (video.muted) {
        unmute();
      } else {
        video.muted = true;
        syncToggle();
      }
    });

    video.addEventListener('click', function () {
      if (video.muted) unmute();
    });

    syncToggle();
  }

  document.querySelectorAll('[data-mdb-lp-video]').forEach(initMdbLpMedia);
})();
